export default "__VITE_ASSET__BTP382uc__"